import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDownload(props: SvgIconProps) {
  return (
    <SVGIcon width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 10V12C1 13.1046 1.89543 14 3 14H13C14.1046 14 15 13.1046 15 12V10"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M4.00012 6L8.00012 10L12.0001 6" stroke="currentColor" strokeWidth="2" />
      <path d="M8.00012 10L8.00012 0" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
